<template>
  <div class="card my-3 bg-primary text-white overflow-hidden">
    <div class="card-body">
      <figure class="d-flex text-condensed text-uppercase font-weight-bold justify-content-between flex-wrap">
        <div class="flex-shrink-0">
          <h2
            v-if="header"
            class="mb-4 text-white opacity-70"
          >
            {{ header }}
          </h2>

          <div class="d-flex align-items-end">
            <span :class="['flex-shrink-0', $style.fsBig]">
              {{ $formatTemperature(temp, true) }}
            </span>
            <span
              v-if="tempH !== undefined && tempL !== undefined"
              class="flex-grow-1 ml-2 text-condensed text-uppercase font-weight-bold mb-2"
            >
              <i18n
                tag="div"
                path="location.temperatureHigh"
              >{{ $formatTemperature(tempH, true) }}</i18n>
              <i18n
                tag="div"
                path="location.temperatureLow"
              >{{ $formatTemperature(tempL, true) }}</i18n>
            </span>
          </div>
        </div>
        <img
          v-if="icon"
          :src="require(`@/assets/weather/${mapIcon(icon)}.png`)"
          :alt="$t(`weather.${icon}`)"
          :title="$t(`weather.${icon}`)"
          width="160"
          height="160"
        >
      </figure>

      <section class="row no-gutters flex-wrap text-condensed text-uppercase font-weight-bold">
        <div
          v-for="({value, translation}, key) in weatherDetails"
          :key="key"
          class="col-4 d-flex flex-column mb-4"
        >
          <span
            :class="$style.value"
            class="mb-1"
            v-text="value"
          />
          <span
            v-t="translation"
            :class="[$style.label, 'opacity-70']"
          />
        </div>

        <div class="mt-4 text-center w-100">
          <img
            src="@/assets/UBI_Logo.svg"
            alt="ubimet"
            width="123"
            height="16"
          >
        </div>
      </section>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { METRIC } from '@/constants/units'

export default {
  name: 'WeatherWidget',
  props: {
    header: {
      type: String,
      default: undefined
    },
    temp: {
      type: Number,
      default: undefined
    },
    tempL: {
      type: Number,
      default: undefined
    },
    tempH: {
      type: Number,
      default: undefined
    },
    icon: {
      type: Number,
      default: undefined
    },
    humidity: {
      type: Number,
      default: undefined
    },
    pressure: {
      type: Number,
      default: undefined
    },
    precipiation: {
      type: Number,
      default: undefined
    },
    wind: {
      type: Number,
      default: undefined
    },
    uv: {
      type: Number,
      default: undefined
    }
  },
  computed: {
    ...mapGetters([
      'unitSpeed',
      'units'
    ]),
    unitPressure() {
      return this.units === METRIC ? 'hPa' : 'inHg'
    },
    weatherDetails() {
      return {
        humidity: {
          value: `${this.humidity} %`,
          translation: 'location.humidity'
        },
        pressure: {
          value: this.$formatPressure(this.pressure, false),
          translation: { path: 'location.pressure', args: { unit: this.unitPressure } }
        },
        uv: {
          value: this.uv,
          translation: 'location.uv'
        },
        wind: {
          value: this.$formatSpeed(this.wind, false),
          translation: { path: 'location.wind', args: { unit: this.unitSpeed } }
        },
        precipiation: {
          value: `${this.precipiation} %`,
          translation: { path: 'location.precipiation', args: { unit: '%' } }
        }
      }
    }
  },
  methods: {
    mapIcon(icon) {
      const mapping = [
        1, 2, 2, 3, 3, 4, 4, 5, 6, 6, 5, 7, 7, 8, 8, 5, 9, 9, 6, 11, 11, 10, 11, 11, 10, 12, 12, 12, 13,
        13, 12, 13, 13, 12, 12, 12, 12, 13, 13, 12, 13, 13, 12, 14, 12, 7, 15, 4, 4, 1
      ]
      const idx = parseInt(icon, 10)
      return (idx > 0 && idx < mapping.length - 1) ? mapping[idx - 1] : 1
    }
  }
}
</script>

<style lang="scss" module>
.bg {
  color: $white;
  background: linear-gradient(218.49deg, #469DD8 0%, #94C6E0 100%);
}

.fsBig {
  font-size: 5.5rem;
  line-height: 1;
}

.value {
  font-size: 2rem;
  line-height: 1.125;
}

.label {
  font-size: $font-size-sm;
}
</style>
